import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { UserVoluntaryService } from '../../user/user-voluntary.service';

const API_URL = environment.apiUrl;

@Injectable()
export class AuthVoluntaryService {
  constructor(
    private http: HttpClient,
    private userVoluntaryService: UserVoluntaryService
  ) {}

  login(email: string, password: string): Observable<any> {
    const loginData = { email, password };

    return this.http
      .post(API_URL + '/voluntary_login_check', loginData, { observe: 'response' })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userVoluntaryService.setToken(authToken);
        }),
        map((res: any) => res.body)
      );
  }

  logout(): void {
    this.userVoluntaryService.logout();
  }

  forgotPassword(body: any): Observable<any> {
    return this.http.post(API_URL + '/voluntary-resetting-password-request', body);
  }

  validateResetToken(token: string): Observable<any> {
    return this.http.get(
      API_URL + '/voluntary-resetting-password-verify-token/' + token,
      {}
    );
  }

  resetPassword(body: any): Observable<any> {
    return this.http.post(API_URL + '/voluntary-resetting-password-reset', body);
  }

  changePassword(body: any, userId: number): Observable<any> {
    return this.http
      .put(API_URL + '/voluntaries/' + userId + '/change-password', body, {
        observe: 'response',
      })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userVoluntaryService.setToken(authToken);
        })
      );
  }

  refreshToken(): Observable<any> {
    return this.http
      .get(API_URL + '/voluntary-refresh-token', { observe: 'response' })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userVoluntaryService.setToken(authToken);
        })
      );
  }
}
